<p-dialog
  [header]="'Solicitar cuenta Depa (' + currencyCode + ')'"
  [modal]="true"
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [style]="{ width: '640px', maxWidth: '92vw' }"
  [maximizable]="true"
  appendTo="body"
>
  <p class="p-text-secondary mb-3">
    Usa esta solicitud si el alta automática falló al aprobar KYC.
    Se crea la cuenta
    <strong>{{ currencyCode }}</strong>
    en Depa para
    <strong>{{ username || ('usuario ' + userId) }}</strong>
    como
    <strong>{{ identityKindLabel }}</strong>.
  </p>

  <div class="permissions-state" *ngIf="costsLoading">
    <i class="pi pi-spin pi-spinner"></i>
    Consultando costos de alta y mantenimiento
  </div>

  <div class="costs-error" *ngIf="!costsLoading && costsError">
    {{ costsError }}
  </div>

  <div class="costs-card" *ngIf="!costsLoading && costs">
    <div class="costs-row">
      <span>Proveedor</span>
      <strong>
        {{
          costs.priority_selection?.provider_username ||
            costs.selected_provider_service?.provider?.username ||
            'Depa'
        }}
      </strong>
    </div>
    <div class="costs-row">
      <span>Alta ({{ feeTypeLabel(costs.summary?.creation, 'bankaccount_setup') }})</span>
      <strong>{{ formatFee(costs.summary?.creation) }}</strong>
    </div>
    <div class="costs-row">
      <span>Mantenimiento ({{ feeTypeLabel(costs.summary?.maintenance, 'bankaccount_maintenance') }})</span>
      <strong>{{ formatFee(costs.summary?.maintenance) }}</strong>
    </div>
  </div>

  <div class="form-item">
    <label>Alias (opcional)</label>
    <input type="text" pInputText class="w-full" [(ngModel)]="alias" maxlength="120" />
  </div>

  <div class="accept-row">
    <p-checkbox
      [(ngModel)]="acceptedCosts"
      [binary]="true"
      inputId="depaAcceptedCosts"
      [disabled]="submitting || !!costsError"
    />
    <label for="depaAcceptedCosts">
      Acepto los costos de creación y mantenimiento de esta cuenta.
    </label>
  </div>

  <button
    type="button"
    class="identity-toggle"
    (click)="showIdentityForm = !showIdentityForm"
  >
    {{ showIdentityForm ? 'Ocultar' : 'Revisar' }} identidad {{ identityKindLabel }}
  </button>

  <p class="identity-hint" *ngIf="identityReason">
    {{ identityReason }}
    <span *ngIf="missingIdentityFields.length">
      Faltan: {{ missingIdentityFields.join(', ') }}.
    </span>
  </p>

  <div class="identity-grid" *ngIf="showIdentityForm">
    <div class="form-item" *ngFor="let field of softKycFields">
      <label>{{ field.label }}</label>
      <p-dropdown
        *ngIf="field.key === 'document_type'"
        [(ngModel)]="softKyc['document_type']"
        [options]="documentTypeOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        styleClass="w-full"
      />
      <input
        *ngIf="field.key !== 'document_type'"
        type="text"
        pInputText
        class="w-full"
        [(ngModel)]="softKyc[field.key]"
      />
    </div>
  </div>

  <p class="request-error" *ngIf="requestError">{{ requestError }}</p>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      severity="danger"
      [disabled]="submitting"
      (click)="close()"
    />
    <p-button
      [label]="submitting ? 'Solicitando…' : 'Solicitar cuenta'"
      severity="secondary"
      [loading]="submitting"
      [disabled]="submitting || costsLoading || !!costsError || !acceptedCosts"
      (click)="submit()"
    />
  </ng-template>
</p-dialog>
